import { httpClient } from '../lib/http-client';
import { LoginData, LoginResponse } from '../types';

/**
 * Service para autenticação
 */
export class AuthService {
  /**
   * Realiza login do usuário
   */
  static async login(credentials: LoginData): Promise<LoginResponse> {
    try {
      const response = await httpClient.post<LoginResponse>('/api/login', credentials);
      return response;
    } catch (error: any) {
      if (error.response?.data) {
        throw new Error(error.response.data.error || 'Erro ao fazer login');
      }
      throw new Error('Erro de comunicação com o servidor');
    }
  }

  /**
   * Verifica se o servidor está online
   */
  static async ping(): Promise<{ pong: boolean }> {
    return httpClient.get('/api/ping');
  }
}

